import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import moment, { isMoment } from 'moment';
import { DialogStopSchedulingSuggestionsComponent } from '../../dialogs/dialog-edit-maintenance/tabs/maintenance/dialog-stop-scheduling-suggestions/dialog-stop-scheduling-suggestions.component';
import { DialogSchedulingSuggestionsComponent } from '../../dialogs/dialog-scheduling-suggestions/dialog-scheduling-suggestions.component';
import { ConfirmDeleteNewSchedulingSuggestionsComponent } from './confirm-delete-new-scheduling-suggestions/confirm-delete-new-scheduling-suggestions.component';
var ScheduleSuggestionsComponent = /** @class */ (function () {
    function ScheduleSuggestionsComponent(matDialog, maintenancesApi, customMessageService) {
        this.matDialog = matDialog;
        this.maintenancesApi = maintenancesApi;
        this.customMessageService = customMessageService;
        this.isLoading = new EventEmitter();
        this.sheduleSuggestionsContainersToShow = {
            addSuggestion: false,
            ongoingSuggestions: false,
            corporateAccepted: false,
            scheduleSuggestions: false
        };
    }
    ScheduleSuggestionsComponent.prototype.ngOnInit = function () {
        this.scheduleSuggestionsFormArray = this.form.get('scheduleSuggestions');
        this.companyScheduleSuggestionIsRetroactiveDate = this.checkIfCompanyScheduleSuggestionIsRetroactiveDate();
        this.shouldShowButtonsOnOngoingScheduleSuggestions = this.shouldShowButtons();
        this.validateRetroativeDateOnSheduleSuggestions();
        this.updateScheduleSuggestionsContainersToShow();
    };
    ScheduleSuggestionsComponent.prototype.updateScheduleSuggestionsContainersToShow = function () {
        var statusForm = this.form.get('status');
        var scheduleSuggestionsStatusForm = this.form.get('scheduleSuggestionsStatus');
        var hasScheduleSuggestions = this.scheduleSuggestionsFormArray.value && this.scheduleSuggestionsFormArray.value.length >= 1;
        var isOnReallocationDialog = this.form.get('newCompany');
        var isOnReopenDialog = this.form.get('reopenReason');
        var hasCompanyScheduleSuggestion = this.form.get('companyScheduleSuggestion') && this.form.get('companyScheduleSuggestion').value;
        var isNewOrRequestedMaintenance = (!hasScheduleSuggestions && !hasCompanyScheduleSuggestion && !statusForm) || (statusForm && (statusForm.value === 'new' || statusForm.value === 'requested'));
        var isOnNegotiation = statusForm && statusForm.value === 'onNegotiation';
        var isCanceled = statusForm && statusForm.value === 'canceled';
        var isStandardSuggested = scheduleSuggestionsStatusForm && scheduleSuggestionsStatusForm.value === 'standardSuggested';
        var isSuggestionStopped = scheduleSuggestionsStatusForm && scheduleSuggestionsStatusForm.value === 'suggestionStopped';
        var isCorporateAccepted = scheduleSuggestionsStatusForm && scheduleSuggestionsStatusForm.value === 'corporateAccepted';
        var isNewScheduleSuggestion = scheduleSuggestionsStatusForm && scheduleSuggestionsStatusForm.value === 'newScheduleSuggestion';
        this.sheduleSuggestionsContainersToShow.addSuggestion = false;
        this.sheduleSuggestionsContainersToShow.ongoingSuggestions = false;
        this.sheduleSuggestionsContainersToShow.corporateAccepted = false;
        this.sheduleSuggestionsContainersToShow.scheduleSuggestions = false;
        if (!isNewScheduleSuggestion &&
            (Boolean(isNewOrRequestedMaintenance && !hasScheduleSuggestions) ||
                Boolean(!hasScheduleSuggestions && (isOnReallocationDialog || isOnReopenDialog)) ||
                Boolean(isSuggestionStopped && (isOnReallocationDialog || isOnReopenDialog)) ||
                Boolean(isOnNegotiation && isStandardSuggested && (isOnReallocationDialog || isOnReopenDialog)) ||
                Boolean(isCorporateAccepted && (isOnReallocationDialog || isOnReopenDialog)) ||
                Boolean(isCanceled && (isOnReallocationDialog || isOnReopenDialog) && !hasScheduleSuggestions))) {
            this.sheduleSuggestionsContainersToShow.addSuggestion = true;
        }
        else if ((this.scheduleSuggestionsFormArray &&
            this.scheduleSuggestionsFormArray.value &&
            this.scheduleSuggestionsFormArray.value.length > 0) &&
            ((!isStandardSuggested || isCanceled) && !isCorporateAccepted && !isSuggestionStopped)) {
            this.sheduleSuggestionsContainersToShow.ongoingSuggestions = true;
        }
        else if (isCorporateAccepted && !isOnReallocationDialog) {
            this.sheduleSuggestionsContainersToShow.corporateAccepted = true;
        }
        else if (isOnNegotiation && isStandardSuggested) {
            this.sheduleSuggestionsContainersToShow.scheduleSuggestions = true;
        }
    };
    ScheduleSuggestionsComponent.prototype.openSchedulingSuggestionsDialog = function () {
        var _this = this;
        var schedulingSuggestionDialog = this.matDialog.open(DialogSchedulingSuggestionsComponent, {
            panelClass: ['scheduling-suggestions'],
            width: '553px',
            disableClose: true,
            data: this.form
        });
        schedulingSuggestionDialog.afterClosed().subscribe(function () {
            _this.updateScheduleSuggestionsContainersToShow();
            _this.validateRetroativeDateOnSheduleSuggestions();
        });
    };
    ScheduleSuggestionsComponent.prototype.openConfirmDeleteNewSchedulingSuggestionsDialog = function () {
        var _this = this;
        var confirmDeleteDialog = this.matDialog.open(ConfirmDeleteNewSchedulingSuggestionsComponent, {
            panelClass: ['confirm-delete-new-scheduling-suggestions'],
            width: '464px',
            disableClose: true,
            data: this.form
        });
        confirmDeleteDialog.afterClosed().subscribe(function () {
            _this.updateScheduleSuggestionsContainersToShow();
        });
    };
    ScheduleSuggestionsComponent.prototype.openStopSchedulingSuggestionsDialog = function () {
        var _this = this;
        this.matDialog.open(DialogStopSchedulingSuggestionsComponent, {
            panelClass: ['stop-scheduling-suggestions'],
            width: '464px',
            data: this.form
        }).componentInstance.isLoading.subscribe(function (reload) {
            _this.isLoading.next(reload);
        });
    };
    ScheduleSuggestionsComponent.prototype.validateRetroativeDateOnSheduleSuggestions = function () {
        this.corporateScheduleSuggestionsHasRetroactiveDate = this.checkIfCorporateScheduleSuggestionsHasRetroactiveDate();
        if (this.corporateScheduleSuggestionsHasRetroactiveDate) {
            this.form.get('scheduleSuggestions').setErrors({
                invalid: true
            });
        }
    };
    ScheduleSuggestionsComponent.prototype.checkIfCompanyScheduleSuggestionIsRetroactiveDate = function () {
        if (!this.form.get('companyScheduleSuggestion')) {
            return false;
        }
        if (!this.form.get('scheduleSuggestionsStatus')) {
            return false;
        }
        if (this.form.get('scheduleSuggestionsStatus').value !== 'standardSuggested') {
            return false;
        }
        if (!this.form.get('companyScheduleSuggestion').value) {
            return false;
        }
        var companyScheduleSuggestion = this.form.get('companyScheduleSuggestion').value;
        var currentDate = moment();
        var selectedDateTime = moment(companyScheduleSuggestion.date + " " + companyScheduleSuggestion.time, 'YYYY-MM-DD HH:mm');
        var isDateToday = companyScheduleSuggestion.date === moment(currentDate).format('YYYY-MM-DD');
        if (isDateToday && !companyScheduleSuggestion.time) {
            return false;
        }
        if (selectedDateTime.isBefore(currentDate)) {
            return true;
        }
        return false;
    };
    ScheduleSuggestionsComponent.prototype.checkIfCorporateScheduleSuggestionsHasRetroactiveDate = function () {
        if (!this.scheduleSuggestionsFormArray.value || !this.scheduleSuggestionsFormArray.value.length) {
            return false;
        }
        var currentDate = moment();
        return this.scheduleSuggestionsFormArray.value.some(function (scheduleSuggestion) {
            if (isMoment(scheduleSuggestion.date)) {
                scheduleSuggestion.date = moment(scheduleSuggestion.date).format('YYYY-MM-DD');
            }
            var selectedDateTime = moment(scheduleSuggestion.date + " " + scheduleSuggestion.time, 'YYYY-MM-DD HH:mm');
            var isDateToday = scheduleSuggestion.date === currentDate.format('YYYY-MM-DD');
            if (isDateToday && !scheduleSuggestion.time) {
                return false;
            }
            return selectedDateTime.isBefore(currentDate);
        });
    };
    ScheduleSuggestionsComponent.prototype.shouldShowButtons = function () {
        var scheduleSuggestionsStatus = this.form.get('scheduleSuggestionsStatus');
        var isOnReallocationDialog = this.form.get('newCompany');
        var maintenanceStatus = this.form.get('status');
        var isOnReopenDialog = this.form.get('reopenReason');
        var isMaintenanceRequested = Boolean(maintenanceStatus && maintenanceStatus.value === 'requested');
        return Boolean(isMaintenanceRequested || !maintenanceStatus ||
            ((maintenanceStatus && maintenanceStatus.value !== 'canceled' || (isOnReallocationDialog || isOnReopenDialog)) &&
                ((isOnReallocationDialog || isOnReopenDialog) ||
                    ((scheduleSuggestionsStatus && scheduleSuggestionsStatus.value !== 'corporateSuggested' &&
                        (scheduleSuggestionsStatus.value !== 'corporateRefused')) ||
                        scheduleSuggestionsStatus.value === 'newScheduleSuggestion' ||
                        (maintenanceStatus && maintenanceStatus.value === 'new' &&
                            scheduleSuggestionsStatus && scheduleSuggestionsStatus.value === 'corporateSuggested')))));
    };
    ScheduleSuggestionsComponent.prototype.acceptMaintenanceScheduleSuggestions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenance, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.isLoading.emit(true);
                        return [4 /*yield*/, this.maintenancesApi.acceptMaintenanceScheduleSuggestions(this.maintenanceId).toPromise()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.maintenancesApi.searchOne(this.maintenanceId).toPromise()];
                    case 2:
                        maintenance = _a.sent();
                        this.form.get('status').setValue(maintenance.status);
                        this.form.get('scheduleSuggestionsStatus').setValue(maintenance.scheduleSuggestionsStatus);
                        this.customMessageService.success('MAINTENANCES.SCHEDULE_SUGGESTIONS.ACCEPT_MAINTENANCE_SCHEDULE_SUGGESTIONS.SUCCESS');
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        this.customMessageService.error('MAINTENANCES.SCHEDULE_SUGGESTIONS.ACCEPT_MAINTENANCE_SCHEDULE_SUGGESTIONS.ERROR');
                        return [3 /*break*/, 5];
                    case 4:
                        this.updateScheduleSuggestionsContainersToShow();
                        this.isLoading.emit(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return ScheduleSuggestionsComponent;
}());
export { ScheduleSuggestionsComponent };
